import ColumnChart from './ColumnChart';

export default ColumnChart;
